import { Component, Input } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';

@Component({
    imports: [AngularSvgIconModule, AnalyticsDirective],
    selector: 'rdx-planned-ride-warning-message',
    standalone: true,
    styleUrls: ['./planned-ride-warning-message.component.scss'],
    templateUrl: './planned-ride-warning-message.component.html',
})
export class PlannedRideWarningMessageComponent {
    @Input() hasUnroutableError = false;

    constructor(private confirmationDialogService: ConfirmationDialogService) {}

    openPlannedRideMaxPointMessage() {
        this.confirmationDialogService.openPlannedRideMaxPointMessage();
    }
}
